<template>
    <div>
        <v-view :tableData="tableData"
                :tableProps="tableProps"
                :modalProps="modalProps"
                :columns="columns"
                :routes="routes"
                :initialSort="initialSort"
                :rowButtonAction="rowButtonAction"
                :buttonsVisibility="buttonsVisibility"
                v-model:selectedRows="selectedRows">

            <template #crud="formProps">
                <ProductForm :formProps="formProps">
                </ProductForm>
            </template>
            <template #search="searchProps">
                <ProductSearch :searchProps="searchProps">
                </ProductSearch>
            </template>
        </v-view>
    </div>
</template>

<script setup>
import ProductForm from './ProductForm.vue'
import ProductSearch from './ProductSearch.vue'
import { rowButtonAction } from '@pages/Helper/crud_utils.js'
import { ref } from "vue";

const props = defineProps({
    tableData: Object,
    tableProps: Object,
    modalProps: Object,
    columns: Object,
    routes: Object,
    initialSort: Object,
    buttonsVisibility: Object,
})

const selectedRows = ref([])

//------------------------------------------------------------------------------

</script>

<style lang="scss" scoped></style>
